import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import css from './globalRegistrationPopup.module.css';

const GlobalRegistrationPopup = ({ authUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isHiding, setIsHiding] = useState(false);

  const isAuthenticated = authUser?.isAuthenticated;

  useEffect(() => {
    // Only show if not authenticated
    if (isAuthenticated) {
      setIsVisible(false);
      return;
    }

    // Determine when to show the popup based on the current path
    const path = location.pathname;
    let timer;

    if (path.startsWith('/lesson/')) {
      // Show immediately on lesson pages
      timer = setTimeout(() => setIsVisible(true), 2000);
    } else if (path === '/survey') {
      // Show on survey page as part of Design 33
      timer = setTimeout(() => setIsVisible(true), 500);
    } else {
      // Hide on other pages
      setIsVisible(false);
    }

    return () => clearTimeout(timer);
  }, [isAuthenticated, location.pathname]);

  const handleClose = () => {
    setIsHiding(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsHiding(false);
    }, 300);
  };

  const handleRegister = () => {
    navigate('/signup');
    handleClose();
  };

  if (!isVisible && !isHiding) return null;

  return (
    <div className={`${css.overlay} ${isHiding ? css.fadeOut : ''}`}>
      <div className={`${css.popup} ${isHiding ? css.scaleOut : ''}`}>
        <button className={css.closeBtn} onClick={handleClose}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>

        <div className={css.iconWrap}>
          <div className={css.pulseBg}></div>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        </div>

        <h3 className={css.title}>{t('registrationPopup.title', 'Збережіть свій прогрес!')}</h3>
        <p className={css.desc}>
          {t('registrationPopup.desc', 'Ви зараз навчаєтесь як гість. Створіть безкоштовний акаунт, щоб зберігати вивчені слова, пройдені уроки та персональний план.')}
        </p>

        <div className={css.benefits}>
          <div className={css.benefitItem}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            {t('registrationPopup.b1', 'Особистий кабінет')}
          </div>
          <div className={css.benefitItem}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            {t('registrationPopup.b2', 'Персональний план')}
          </div>
          <div className={css.benefitItem}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            {t('registrationPopup.b3', 'Збереження прогресу')}
          </div>
        </div>

        <div className={css.actions}>
          <button className={css.btnPrimary} onClick={handleRegister}>
            {t('registrationPopup.register', 'Зареєструватися безкоштовно')}
          </button>
          <button className={css.btnSecondary} onClick={handleClose}>
            {t('registrationPopup.later', 'Продовжити як гість')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalRegistrationPopup;
